export const BOOKING_DURATION_IN_MINUTES = 60;
